
export default {
  // Auth-related translations
  "sign_in": "登录",
  "sign_up": "注册",
  "email_address": "电子邮箱",
  "password": "密码",
  "new_password": "新密码",
  "confirm_password": "确认密码",
  "forgot_password": "忘记密码？",
  "reset_password": "重置密码",
  "verification_code": "验证码",
  "enter_verification_code": "输入发送到您邮箱的6位数验证码",
  "passwords_dont_match": "密码不匹配",
  "password_too_short": "密码至少需要8个字符",
  "invalid_code": "无效或过期的验证码",
  "invalid_code_format": "验证码必须是6位数字",
  "password_reset_success": "密码重置成功",
  "send_reset_link": "发送临时密码",
  "reset_link_sent": "重置链接已发送到您的邮箱",
  "temp_password_sent": "临时密码已发送到您的邮箱",
  "reset_link_error": "发送重置链接失败，请稍后再试",
  "email_delivery_not_configured": "邮件发送未配置，请联系管理员",
  "for_testing_use": "对于开发测试，您可以使用Supabase CLI或仪表板来管理用户",
  "processing": "处理中...",
  "back": "返回",
  "verify_code": "输入验证码",
  "email_not_received": "没收到邮件？",
  "leave_page_warning": "您有未保存的更改。确定要离开此页面吗？您的密码重置进度将丢失。",
  "reset_link_required": "重置密码需要有效的重置链接",
  // New rate limit messages
  "reset_rate_limit_exceeded": "邮件发送频率超出限制，请稍后再试。",
  "reset_rate_limit_message": "请等待 {{seconds}} 秒后再请求临时密码。",
  "wait_before_retry": "请稍等再试",
  // Temporary password messages
  "password_reset_required": "您必须更改密码才能继续",
  "temp_password_instructions": "您正在使用临时密码。请创建新密码。",
  
  // Username dialog related translations
  "create_username": "创建用户名",
  "username_required_description": "请创建一个用户名以继续。您的用户名将对其他用户可见。",
  "username": "用户名",
  "username_placeholder": "输入用户名",
  "username_requirements": "用户名只能包含字母、数字和下划线。",
  "save_username": "保存用户名",
  "username_taken": "此用户名已被占用。请尝试另一个。",
  "username_set_success": "用户名设置成功！",
  "username_set_error": "设置用户名失败。请重试。",
  "auth_error": "认证错误。请重新登录。"
};
